/**
 * @ngdoc service
 * @name mx.SolutionBuilderAgent.FilterExpressionService
 * @module mx.SolutionBuilderAgent
 *
 * @description
 * A service provides methods for evaluating filter expressions.
 */
import type { HttpService } from '../../../App/services/http-service';
import { DataTypes } from '../model/enumerations';

export interface IValidationResultParameter {
	IsArray: boolean;
	Name: string;
	ParameterType: DataTypes;
}

export interface ValidationResult {
	IsValid?: boolean;
	ErrorMessage?: string;
	Parameters: Array<IValidationResultParameter>;
}

export class FilterExpressionService {
	static $inject = ['mx.SolutionBuilderAgent.Http'];
	constructor(private readonly http: HttpService) {}

	async validateFilterExpressionDataQuery(expression: string | null, dataQueryId: string) {
		if (!expression) {
			return this.createValidateResult({ IsValid: true, Parameters: [] });
		}
		const result = await this.http.get<ValidationResult>(`api/schema/evaluateparameterexpressiondataquery?dataqueryid=${dataQueryId}&expr=${encodeURIComponent(expression)}`);
		return this.createValidateResult(result);
	}

	async validateFilterExpressionEntityClass(expression: string | null, entityclass: string) {
		if (!expression) {
			return this.createValidateResult({ IsValid: true, Parameters: [] });
		}
		const result = await this.http.get<ValidationResult>(`api/schema/evaluateparameterexpressionentityclass?entityclass=${entityclass}&expr=${encodeURIComponent(expression)}`);
		return this.createValidateResult(result);
	}

	async getParametersForExpressionDataQuery(expression: string, dataQueryId: string) {
		return await this.http.get<ValidationResult>(`api/schema/evaluateparameterexpressiondataquery?dataqueryid=${dataQueryId}&expr=${encodeURIComponent(expression)}`);
	}

	async getParametersForExpressionEntityClass(expression: string, entityclass: string) {
		return await this.http.get<ValidationResult>(`api/schema/evaluateparameterexpressionentityclass?entityclass=${entityclass}&expr=${encodeURIComponent(expression)}`);
	}

	async getParametersForExpression(expression: string) {
		return await this.http.get<ValidationResult>(`api/schema/evaluateParameterExpression?expr=${encodeURIComponent(expression)}`);
	}

	private createValidateResult(data: ValidationResult) {
		return { isValid: !!data.IsValid, message: data.ErrorMessage || '' };
	}
}
